import { transformDataFrame } from '@grafana/data';
import { map } from 'rxjs';
import { sceneGraph } from '../core/sceneGraph.js';
import { SceneObjectBase } from '../core/SceneObjectBase.js';
import { VariableDependencyConfig } from '../variables/VariableDependencyConfig.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class SceneDataTransformer extends SceneObjectBase {
  constructor(state) {
    super(state);
    this._variableDependency = new VariableDependencyConfig(
      this,
      {
        statePaths: ["transformations"],
        onReferencedVariableValueChanged: () => this.reprocessTransformations()
      }
    );
    this.addActivationHandler(() => this.activationHandler());
  }
  activationHandler() {
    const sourceData = this.getSourceData();
    this._subs.add(sourceData.subscribeToState((state) => this.transform(state.data)));
    if (sourceData.state.data) {
      this.transform(sourceData.state.data);
    }
    return () => {
      if (this._transformSub) {
        this._transformSub.unsubscribe();
      }
    };
  }
  getSourceData() {
    if (this.state.$data) {
      return this.state.$data;
    }
    if (!this.parent || !this.parent.parent) {
      throw new Error("SceneDataTransformer must either have $data set on it or have a parent.parent with $data");
    }
    return sceneGraph.getData(this.parent.parent);
  }
  setContainerWidth(width) {
    if (this.state.$data && this.state.$data.setContainerWidth) {
      this.state.$data.setContainerWidth(width);
    }
  }
  reprocessTransformations() {
    this.transform(this.getSourceData().state.data);
  }
  transform(data) {
    const transformations = this.state.transformations || [];
    if (transformations.length === 0 || !data) {
      this.setState({ data });
      return;
    }
    if (this._transformSub) {
      this._transformSub.unsubscribe();
    }
    const ctx = {
      interpolate: (value) => {
        var _a;
        return sceneGraph.interpolate(this, value, (_a = data.request) == null ? void 0 : _a.scopedVars);
      }
    };
    this._transformSub = transformDataFrame(transformations, data.series, ctx).pipe(map((series) => __spreadProps(__spreadValues({}, data), { series }))).subscribe((data2) => this.setState({ data: data2 }));
  }
}

export { SceneDataTransformer };
//# sourceMappingURL=SceneDataTransformer.js.map
